var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackToVideo = function SvgBackToVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M16.3 16.1h1.8m-1.8 2.2h1.8m-6.263 1.375a7.838 7.838 0 1 1 7.838-7.838m-4.95 2.063h4.95c.456 0 .825.37.825.825v4.95c0 .456-.37.825-.825.825h-4.95a.825.825 0 0 1-.825-.825v-4.95c0-.456.37-.825.825-.825Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.9 11.425 9.775 8.95v4.95z"
  })));
};
export { SvgBackToVideo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuMyAxNi4xaDEuOG0tMS44IDIuMmgxLjhtLTYuMjYzIDEuMzc1YTcuODM4IDcuODM4IDAgMSAxIDcuODM4LTcuODM4bS00Ljk1IDIuMDYzaDQuOTVjLjQ1NiAwIC44MjUuMzcuODI1LjgyNXY0Ljk1YzAgLjQ1Ni0uMzcuODI1LS44MjUuODI1aC00Ljk1YS44MjUuODI1IDAgMCAxLS44MjUtLjgyNXYtNC45NWMwLS40NTYuMzctLjgyNS44MjUtLjgyNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjxwYXRoIGQ9Ik0xMy45IDExLjQyNSA5Ljc3NSA4Ljk1djQuOTVsNC4xMjUtMi40NzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";